import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/App.css';
import { Security } from '@okta/okta-react';
import { isDevelopment, oktaConfig } from './config/oktaConfig';
import AppContextProvider from './contexts/AppContext.tsx';
import DialogContextProvider from './contexts/DialogContext.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'react-hot-toast';
import { OktaAuth } from '@okta/okta-auth-js';

// TypeScript only:
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient;
  }
}

// Configuration Okta - plus besoin des CONNECTIONS
const oktaAuth = new OktaAuth(oktaConfig);

if (import.meta.env.VITE_ENVIRONMENT === 'prod') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

if (isDevelopment) {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient;
}

const toastOptions = {
  duration: 8000,
  style: {
    padding: '20px',
    fontFamily: 'Roboto,"Helvetica Neue",Arial,sans-serif',
  },
  success: {
    style: {
      background: '#3dbe6c',
      color: 'white',
    },
    iconTheme: {
      primary: 'white',
      secondary: '#3dbe6c',
    },
  },
  error: {
    style: {
      background: '#e74c3c',
      color: 'white',
    },
    iconTheme: {
      primary: 'white',
      secondary: '#e74c3c',
    },
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppContextProvider>
      <Security
        oktaAuth={oktaAuth}
        restoreOriginalUri={(_oktaAuth, originalUri) => {
          // Éviter la redirection vers /login/undefined
          if (originalUri && originalUri !== '/login/undefined') {
            window.location.replace(originalUri);
          } else {
            // Redirection par défaut vers /projects si originalUri est undefined ou invalide
            window.location.replace('/projects');
          }
        }}
      >
        <DialogContextProvider>
          <Toaster position="bottom-right" toastOptions={toastOptions} />
          <QueryClientProvider client={queryClient}>
            <App />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </DialogContextProvider>
      </Security>
    </AppContextProvider>
  </React.StrictMode>,
);
